import moment from 'moment';

export const mutations = {
    changeStepActive(state,step){
        if(step <= 6){
            state.stepActive = step;
        }
    },
    loginMutation(state,login){
        state.login = login;
    },
    saveStepOne(state,stepOne){
        state.stepOne = stepOne;
    },
    saveStepTwo(state,stepTwo){
        state.stepTwo = stepTwo;
    },
    saveStepThree(state,stepThree){
        state.stepThree = stepThree;
    },
    saveStepFour(state,stepFour){
        state.stepFour = stepFour;
    },
    saveStepFive(state,stepFive){
        state.stepFive = stepFive;
    },
    saveStepSix(state,stepSix){
        state.stepSix = stepSix;
    },
    selectEjercicio(state,ejercicio){
        state.tiendaSeleccionada = ejercicio;
        if(ejercicio == 'autoservicio'){
            state.ejercicioActivo = 'ejercicio-1';
        }else if(ejercicio == 'sams'){
            state.ejercicioActivo = 'ejercicio-3';
        }
    },
    saveArts(state,articulo){
        state.stepThree.articulo = articulo;
    },
    resetEmulador(state){
        state.stepOne = {
            tipoSolicitud: 'Nueva Solicitud',
            tipoSolicitudAcuerdo: 'Volumen'
        };
        state.stepTwo = {
            pais:'México',
            organizacionCompras:'MX01-AUTOS Y SERVICIO',
            grupoCompras:'M11-Org. Compras MX',
            descripcionSolicitudAcuerdo:'Acuerdo de volumen',
            validoDesdeFecha:'',
            validoHastaFecha:'',
            tipoDeLocacion:'',
            autoRenovacion:false,
            metodoDePago:'Neteo',
            moneda:'Pesos mexicanos',
            calendarioDeLiquidacion:'',
            terminosDePago:'Z000',
            numeroSAP:'',
            pagadorSAP:''
        };
        state.stepThree = {
            tipoDeAportacion:'',
            descripcionAportacion:'',
            valdioDe:'',
            validezA:'',
            baseDeCalculo:'',
            tipoDeDevolucion:'',
            autoAgregarArticulos:true,
            baseArticulo:'',
            niveles:'',
            tipoDeTarifaNivel:'',
            tipoDeEscala:'',
            monedaUM:'MXN',
            region:'',
            formato:'',
            tipoDeDistribucion:'',
            jerarquias:{
                departamento:'',
                descripcionDepartamento:'',
                subclase:'',
                descripcionSubclase:'',
                fineline:'',
                descripcionFineline:'',
            },
            articulo:false,
            valorDesde:'0',
            valorHasta:'99,999,999,999',
            tarifa:''
        };
        state.stepFour = {
            comprador:{
                userid:'',
                nombre:'',
                apellido:''
            },
            dmm:{
                userid:'',
                nombre:'',
                apellido:''
            },
            idProveedorRetailLink:'',
            capturarProveedor:true,
            nombreContactoProveedor:'',
            correoContactoProveedor:'',
            telefonoContactoProveedor:'',
            faxContactoProveedor:'',
            identificacionDelContactoDelProveedor:''
        };
        state.stepFive = {
            visibilidad: 'Visible al proveedor',
            documents:[],
            imprimir:false,
            comentarios:[]
        };

        state.stepActive = 1;

        if(state.ejercicioActivo == 'ejercicio-4'){
            state.ejercicioActivo =  'evaluacion-2';    
        }

        if(state.ejercicioActivo == 'ejercicio-3'){
            state.ejercicioActivo =  'ejercicio-4';    
        }

        if(state.ejercicioActivo == 'ejercicio-2'){
            state.ejercicioActivo =  'evaluacion-1';    
        }

        if(state.ejercicioActivo == 'ejercicio-1'){
            state.ejercicioActivo =  'ejercicio-2';
        }

    },
    calculateResult(state){
        let contador = 0;
        let totalQuestionA = 26;
        let totalQuestionS = 29;

        if(state.ejercicioActivo == 'evaluacion-1'){

            if(state.dataEjercicio1.stepOne.tipoSolicitud == state.stepOne.tipoSolicitud){
                contador++;
                // console.log('1',contador);
            }

            if(state.dataEjercicio1.stepOne.tipoSolicitudAcuerdo == state.stepOne.tipoSolicitudAcuerdo){
                contador++;
                // console.log('2',contador);
            }

            if(state.dataEjercicio1.stepTwo.validoDesdeFecha == moment(state.stepTwo.validoDesdeFecha).format("YYYY-MM-DD")){
                contador++;
                // console.log('3',contador);
            }

            if(state.dataEjercicio1.stepTwo.validoHastaFecha == moment(state.stepTwo.validoHastaFecha).format("YYYY-MM-DD")){
                contador++;
                // console.log('4',contador);
            }

            if(state.dataEjercicio1.stepTwo.tipoDeLocacion == state.stepTwo.tipoDeLocacion){
                contador++;
                // console.log('5',contador);
            }

            if(state.dataEjercicio1.stepTwo.numeroSAP == state.stepTwo.numeroSAP){
                contador++;
                // console.log('6',contador);
            }

            if(state.dataEjercicio1.stepTwo.pagadorSAP == state.stepTwo.pagadorSAP){
                contador++;
                // console.log('7',contador);
            }

            if(state.dataEjercicio1.stepThree.tipoDeAportacion == state.stepThree.tipoDeAportacion.code){
                contador++;
                // console.log('8',contador);
            }

            if(state.dataEjercicio1.stepThree.baseDeCalculo == state.stepThree.baseDeCalculo){
                contador++;
                // console.log('9',contador);
            }

            if(state.dataEjercicio1.stepThree.baseArticulo == state.stepThree.baseArticulo){
                contador++;
                // console.log('10',contador);
            }

            if(state.dataEjercicio1.stepThree.niveles == state.stepThree.niveles){
                contador++;
                // console.log('11',contador);
            }

            if(state.dataEjercicio1.stepThree.tipoDeTarifaNivel == state.stepThree.tipoDeTarifaNivel){
                contador++;
                // console.log('12',contador);
            }

            if(state.dataEjercicio1.stepThree.tipoDeEscala == state.stepThree.tipoDeEscala){
                contador++;
                // console.log('13',contador);
            }

            if(state.dataEjercicio1.stepThree.valorDesde == state.stepThree.valorDesde){
                contador++;
                // console.log('14',contador);
            }

            if(state.dataEjercicio1.stepThree.valorHasta == state.stepThree.valorHasta){
                contador++;
                // console.log('15',contador);
            }

            state.stepThree.tarifa = window.$.trim(state.stepThree.tarifa.replace("%", ""));

            if(state.dataEjercicio1.stepThree.tarifa == state.stepThree.tarifa){
                contador++;
                // console.log('16',contador);
            }

            if(state.stepThree.formato.length > 0){

                let superama = state.stepThree.formato.find((f) => f.descripcion == "SUPERAMA");
                let supercenter = state.stepThree.formato.find((f) => f.descripcion == "WM SUPERCENTER");
                let bodega = state.stepThree.formato.find((f) => f.descripcion == "BODEGA");
                let distribution = state.stepThree.formato.find((f) => f.descripcion == "DISTRIBUTION");

                if(superama){
                    contador++;
                    // console.log('17',contador);
                }

                if(supercenter){
                    contador++;
                    // console.log('18',contador);
                }

                if(bodega){
                    contador++;
                    // console.log('19',contador);
                }

                if(distribution){
                    contador++;
                    // console.log('20',contador);
                }
            }

            if(state.dataEjercicio1.stepThree.tipoDeDistribucion == state.stepThree.tipoDeDistribucion){
                contador++;
                // console.log('21',contador);
            }

            if(state.dataEjercicio1.stepThree.jerarquias.departamento == state.stepThree.jerarquias.departamento){
                contador++;
                // console.log('22',contador);
            }

            if(state.dataEjercicio1.stepThree.jerarquias.fineline == state.stepThree.jerarquias.fineline){
                contador++;
                // console.log('23',contador);
            }


            if(state.dataEjercicio1.stepFour.comprador.userid == state.stepFour.comprador.userid){
                contador++;
                // console.log('24',contador);
            }

            if(state.dataEjercicio1.stepFour.dmm.userid == state.stepFour.dmm.userid){
                contador++;
                // console.log('25',contador);
            }

            if(state.dataEjercicio1.stepFour.idProveedorRetailLink == state.stepFour.idProveedorRetailLink.usuario){
                contador++;
                // console.log('26',contador);
            }
        }

        if(state.ejercicioActivo == 'evaluacion-2'){

            if(state.dataEjercicio2.stepOne.tipoSolicitud == state.stepOne.tipoSolicitud){
                contador++;
                // console.log('1',contador);
            }

            if(state.dataEjercicio2.stepOne.tipoSolicitudAcuerdo == state.stepOne.tipoSolicitudAcuerdo){
                contador++;
                // console.log('2',contador);
            }

            if(state.dataEjercicio2.stepTwo.validoDesdeFecha == moment(state.stepTwo.validoDesdeFecha).format("YYYY-MM-DD")){
                contador++;
                // console.log('3',contador);
            }

            if(state.dataEjercicio2.stepTwo.validoHastaFecha == moment(state.stepTwo.validoHastaFecha).format("YYYY-MM-DD")){
                contador++;
                // console.log('4',contador);
            }

            if(state.dataEjercicio2.stepTwo.tipoDeLocacion == state.stepTwo.tipoDeLocacion){
                contador++;
                // console.log('5',contador);
            }

            if(state.dataEjercicio2.stepTwo.numeroSAP == state.stepTwo.numeroSAP){
                contador++;
                // console.log('6',contador);
            }

            if(state.dataEjercicio2.stepTwo.pagadorSAP == state.stepTwo.pagadorSAP){
                contador++;
                // console.log('7',contador);
            }


            if(state.dataEjercicio2.stepThree.tipoDeAportacion == state.stepThree.tipoDeAportacion.code){
                contador++;
                // console.log('8',contador);
            }

            if(state.dataEjercicio2.stepThree.baseDeCalculo == state.stepThree.baseDeCalculo){
                contador++;
                // console.log('9',contador);
            }

            if(state.dataEjercicio2.stepThree.baseArticulo == state.stepThree.baseArticulo){
                contador++;
                // console.log('10',contador);
            }

            if(state.dataEjercicio2.stepThree.niveles == state.stepThree.niveles){
                contador++;
                // console.log('11',contador);
            }

            if(state.dataEjercicio2.stepThree.tipoDeTarifaNivel == state.stepThree.tipoDeTarifaNivel){
                contador++;
                // console.log('12',contador);
            }

            if(state.dataEjercicio2.stepThree.tipoDeEscala == state.stepThree.tipoDeEscala){
                contador++;
                // console.log('13',contador);
            }

            if(state.dataEjercicio2.stepThree.valorDesde == state.stepThree.valorDesde){
                contador++;
                // console.log('14',contador);
            }

            if(state.dataEjercicio2.stepThree.valorHasta == state.stepThree.valorHasta){
                contador++;
                // console.log('15',contador);
            }

            state.stepThree.tarifa = window.$.trim(state.stepThree.tarifa.replace("$", ""));

            if(state.dataEjercicio2.stepThree.tarifa == state.stepThree.tarifa){
                contador++;
                // console.log('16',contador);
            }

            if(state.stepThree.formato.length > 0){

                let sams = state.stepThree.formato.find((f) => f.descripcion == "SAM´S CLUB");
                let distribution = state.stepThree.formato.find((f) => f.descripcion == "DISTRIBUTION");

                if(sams){
                    contador++;
                    // console.log('17',contador);
                }

                if(distribution){
                    contador++;
                    // console.log('18',contador);
                }
            }

            if(state.dataEjercicio2.stepThree.tipoDeDistribucion == state.stepThree.tipoDeDistribucion){
                contador++;
                // console.log('19',contador);
            }

            if(state.dataEjercicio2.stepThree.jerarquias.departamento == state.stepThree.jerarquias.departamento){
                contador++;
                // console.log('20',contador);
            }

            if(state.dataEjercicio2.stepThree.jerarquias.subclase == state.stepThree.jerarquias.subclase){
                contador++;
                // console.log('21',contador);
            }

            if(state.dataEjercicio2.stepThree.articulo.upc == state.stepThree.articulo.upc){
                contador++;
                // console.log('22',contador);
            }

            if(state.dataEjercicio2.stepThree.articulo.win == state.stepThree.articulo.win){
                contador++;
                // console.log('23',contador);
            }

            if(state.dataEjercicio2.stepThree.articulo.descripcion == state.stepThree.articulo.descripcion){
                contador++;
                // console.log('24',contador);
            }

            if(state.dataEjercicio2.stepThree.articulo.indicador == state.stepThree.articulo.indicador){
                contador++;
                // console.log('25',contador);
            }

            if(state.dataEjercicio2.stepThree.articulo.unidad == state.stepThree.articulo.unidad){
                contador++;
                // console.log('26',contador);
            }

            if(state.dataEjercicio2.stepFour.comprador.userid == state.stepFour.comprador.userid){
                contador++;
                // console.log('27',contador);
            }

            if(state.dataEjercicio2.stepFour.dmm.userid == state.stepFour.dmm.userid){
                contador++;
                // console.log('28',contador);
            }

            if(state.dataEjercicio2.stepFour.idProveedorRetailLink == state.stepFour.idProveedorRetailLink.usuario){
                contador++;
                // console.log('29',contador);
            }
        }


        // console.log(contador,totalQuestionA);
        if(state.tiendaSeleccionada == 'autoservicio'){
            state.calificacion = (contador / totalQuestionA) * 100;
        }else{
            state.calificacion = (contador / totalQuestionS) * 100;
        }
        

    },
    saveEvaluacion(state){
        state.stepActive = 1;

        if(state.ejercicioActivo == 'evaluacion-1'){
            state.dataEjercicio1 = {
                stepOne: state.stepOne,
                stepTwo: state.stepTwo,
                stepThree: state.stepThree,
                stepFour: state.stepFour,
                stepFive: state.stepFive
            }
        }

        if(state.ejercicioActivo == 'evaluacion-2'){
            state.dataEjercicio2 = {
                stepOne: state.stepOne,
                stepTwo: state.stepTwo,
                stepThree: state.stepThree,
                stepFour: state.stepFour,
                stepFive: state.stepFive
            }
        }
    },
    noAlerts(state){
        state.alertas = false;
    },
    setUrl(state,url){
        state.url = url;
    },
    otherIntent(state){
        state.stepOne = state.dataEmpty.stepOne;
        state.stepTwo = state.dataEmpty.stepTwo;
        state.stepThree = state.dataEmpty.stepThree;
        state.stepFour = state.dataEmpty.stepFour;
        state.stepFive = state.dataEmpty.stepFive;

        state.stepActive = 1;

        state.intentos = state.intentos+1;
    },
    resetHARD(state){
        let url = state.url;
        state.url = url;
        state = {
            url:'',
            login: false,
            intentos: 0,
            calificacion:0,
            answersSuccess:0,
            stepActive: 1,
            alertas:true,
            ejercicioActivo: 'ejercicio-1',
            tiendaSeleccionada: '',
            stepOne:{
                tipoSolicitud: 'Nueva Solicitud',
                tipoSolicitudAcuerdo: 'Volumen'
            },
            stepTwo:{
                pais:'México',
                organizacionCompras:'MX01-AUTOS Y SERVICIO',
                grupoCompras:'M11-Org. Compras MX',
                descripcionSolicitudAcuerdo:'Acuerdo de volumen',
                validoDesdeFecha:'',
                validoHastaFecha:'',
                tipoDeLocacion:'',
                autoRenovacion:false,
                metodoDePago:'Neteo',
                moneda:'Pesos mexicanos',
                calendarioDeLiquidacion:'',
                terminosDePago:'Z000',
                numeroSAP:'',
                pagadorSAP:''
            },
            stepThree:{
                tipoDeAportacion:'',
                descripcionAportacion:'',
                valdioDe:'',
                validezA:'',
                baseDeCalculo:'',
                tipoDeDevolucion:'',
                autoAgregarArticulos:true,
                baseArticulo:'',
                niveles:'',
                tipoDeTarifaNivel:'',
                tipoDeEscala:'',
                monedaUM:'MXN',
                region:'',
                formato:'',
                tipoDeDistribucion:'',
                jerarquias:{
                    departamento:'',
                    descripcionDepartamento:'',
                    subclase:'',
                    descripcionSubclase:'',
                    fineline:'',
                    descripcionFineline:'',
                },
                articulo:false,
                valorDesde:'0',
                valorHasta:'99,999,999,999',
                tarifa:''
            },
            stepFour:{
                comprador:{
                    userid:'',
                    nombre:'',
                    apellido:''
                },
                dmm:{
                    userid:'',
                    nombre:'',
                    apellido:''
                },
                idProveedorRetailLink:'',
                capturarProveedor:true,
                nombreContactoProveedor:'',
                correoContactoProveedor:'',
                telefonoContactoProveedor:'',
                faxContactoProveedor:'',
                identificacionDelContactoDelProveedor:''
            },
            stepFive:{
                visibilidad: 'Visible al proveedor',
                documents:[],
                imprimir:false,
                comentarios:[]
            },
            dataEjercicio1:{
                stepOne:{
                    tipoSolicitud: 'Nueva Solicitud',
                    tipoSolicitudAcuerdo: 'Volumen'
                },
                stepTwo:{
                    pais:'México',
                    organizacionCompras:'MX01-AUTOS Y SERVICIO',
                    grupoCompras:'M11-Org. Compras MX',
                    descripcionSolicitudAcuerdo:'Acuerdo de volumen',
                    validoDesdeFecha:'2019-02-01',
                    validoHastaFecha:'2019-12-31',
                    tipoDeLocacion:'100001',
                    autoRenovacion:true,
                    numeroSAP:'Multiples valores seleccionados',
                    pagadorSAP:'1000022565'
                },
                stepThree:{
                    tipoDeAportacion:513,
                    valdioDe:'2019-01-01',
                    validezA:'2019-12-31',
                    baseDeCalculo:'Recepcion',
                    baseArticulo:'Grupo Artículos',
                    niveles:'Monto',
                    tipoDeTarifaNivel:'Porcentual',
                    tipoDeEscala:'Escalonado',
                    valorDesde:'0',
                    valorHasta:'99,999,999,999',
                    tarifa:'2.5',
                    formato:
                    [
                    {"tipoubicacion":10001,"banner":100351,"descripcion":"SUPERAMA"},
                    {"tipoubicacion":10001,"banner":100301,"descripcion":"WM SUPERCENTER"},
                    {"tipoubicacion":10001,"banner":100451,"descripcion":"BODEGA"},
                    {"tipoubicacion":10013,"banner":101051,"descripcion":"DISTRIBUTION"}
                    ],
                    tipoDeDistribucion:'Todas las tiendas',
                    jerarquias:{
                        departamento:'90',
                        fineline:'1301',
                    },
                },
                stepFour:{
                    comprador:{userid:'A0F00TH'},
                    dmm:{userid:'A0N00PC'},
                    idProveedorRetailLink:'76TV7ED'
                }
            },
            dataEjercicio2:{
                stepOne:{
                    tipoSolicitud: 'Nueva Solicitud',
                    tipoSolicitudAcuerdo: 'Volumen'
                },
                stepTwo:{
                    pais:'México',
                    organizacionCompras:'MX01-AUTOS Y SERVICIO',
                    grupoCompras:'M11-Org. Compras MX',
                    descripcionSolicitudAcuerdo:'Acuerdo de volumen',
                    validoDesdeFecha:'2019-03-01',
                    validoHastaFecha:'2019-04-15',
                    tipoDeLocacion:'100017',
                    autoRenovacion:true,
                    numeroSAP:'1000047614',
                    pagadorSAP:'1000047614'
                },
                stepThree:{
                    tipoDeAportacion:506,
                    valdioDe:'2019-03-01',
                    validezA:'2019-04-15',
                    baseDeCalculo:'POS',
                    baseArticulo:'Grupo Artículos',
                    niveles:'Cantidad',
                    tipoDeTarifaNivel:'Monto por Cantidad',
                    tipoDeEscala:'Escalonado',
                    valorDesde:'0',
                    valorHasta:'99,999,999,999',
                    tarifa:'431.03',
                    formato:
                    [
                    {tipoubicacion: 1000017,banner:100551 ,descripcion:'SAM´S CLUB'},
                    {tipoubicacion: 1000019,banner:101051 ,descripcion:'DISTRIBUTION'}
                    ],
                    tipoDeDistribucion:'Todas las tiendas',
                    jerarquias:{
                        departamento:'94',
                        subclase:'004'
                    },
                    articulo:{
                        upc:'41003332002',
                        win:'634391',
                        descripcion:'VENTILAD 56" INDUSTR',
                        indicador:'F',
                        unidad:'EA'
                    }
                },
                stepFour:{
                    comprador:{userid:'A0F00TH'},
                    dmm:{userid:'A0N00PC'},
                    idProveedorRetailLink:'4MM1H2H'
                },
            },
            dataEmpty: {
                stepOne:{
                    tipoSolicitud: 'Nueva Solicitud',
                    tipoSolicitudAcuerdo: 'Volumen'
                },
                stepTwo:{
                    pais:'México',
                    organizacionCompras:'MX01-AUTOS Y SERVICIO',
                    grupoCompras:'M11-Org. Compras MX',
                    descripcionSolicitudAcuerdo:'Acuerdo de volumen',
                    validoDesdeFecha:'',
                    validoHastaFecha:'',
                    tipoDeLocacion:'',
                    autoRenovacion:false,
                    metodoDePago:'Neteo',
                    moneda:'Pesos mexicanos',
                    calendarioDeLiquidacion:'',
                    terminosDePago:'Z000',
                    numeroSAP:'',
                    pagadorSAP:''
                },
                stepThree:{
                    tipoDeAportacion:'',
                    descripcionAportacion:'',
                    valdioDe:'',
                    validezA:'',
                    baseDeCalculo:'',
                    tipoDeDevolucion:'',
                    autoAgregarArticulos:true,
                    baseArticulo:'',
                    niveles:'',
                    tipoDeTarifaNivel:'',
                    tipoDeEscala:'',
                    monedaUM:'',
                    region:'',
                    formato:'',
                    tipoDeDistribucion:'',
                    jerarquias:{
                        departamento:'',
                        descripcionDepartamento:'',
                        subclase:'',
                        descripcionSubclase:'',
                        fineline:'',
                        descripcionFineline:'',
                    },
                    articulo:false,
                    valorDesde:'0',
                    valorHasta:'99,999,999,999',
                    tarifa:''
                },
                stepFour:{
                    comprador:{
                        userid:'',
                        nombre:'',
                        apellido:''
                    },
                    dmm:{
                        userid:'',
                        nombre:'',
                        apellido:''
                    },
                    idProveedorRetailLink:'',
                    capturarProveedor:true,
                    nombreContactoProveedor:'',
                    correoContactoProveedor:'',
                    telefonoContactoProveedor:'',
                    faxContactoProveedor:'',
                    identificacionDelContactoDelProveedor:''
                },
                stepFive:{
                    visibilidad: 'Visible al proveedor',
                    documents:[],
                    imprimir:false,
                    comentarios:[]
                }
            }
        }

    }
}